var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOngoing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    stroke: "#4CAF50",
    strokeWidth: 4,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2A10 10 0 0 1 20 12",
    stroke: "#4CAF50",
    strokeWidth: 4,
    fill: "none",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 3H5C4.44772 3 4 3.44772 4 4V20C4 20.5523 4.44772 21 5 21H15C15.5523 21 16 20.5523 16 20V9L12 3H9Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3V9H17",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 11,
    width: 8,
    height: 2,
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 15,
    width: 8,
    height: 2,
    fill: "#FFC107"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOngoing);
export default __webpack_public_path__ + "static/media/ongoing.6a7c2290c6bd8cefc6c0aebe5d9669c6.svg";
export { ForwardRef as ReactComponent };